import {
  descriptionUI,
  textSchema,
  titleUI,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { FacilityLocatorDescription } from '../../../components/FormDescriptions';
import VaMedicalCenter from '../../../components/FormFields/VaMedicalCenter';
import { emptyObjectSchema } from '../../../definitions';
import content from '../../../locales/en/content.json';
import { FULL_SCHEMA } from '../../../utils/imports';

const TITLE_TEXT = content['insurance-info--facility-title'];
const DESC_TEXT = content['insurance-info--facility-description'];
const INPUT_LABEL = content['insurance-info--appointment-label'];

const { wantsInitialVaContact } = FULL_SCHEMA.properties;

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT, DESC_TEXT),
    'view:preferredFacility': {
      'ui:field': VaMedicalCenter,
    },
    'view:addtlInfo': descriptionUI(FacilityLocatorDescription),
    wantsInitialVaContact: yesNoUI(INPUT_LABEL),
  },
  schema: {
    type: 'object',
    required: ['view:preferredFacility'],
    properties: {
      'view:preferredFacility': {
        type: 'object',
        required: ['view:facilityState', 'vaMedicalFacility'],
        properties: {
          'view:facilityState': textSchema,
          vaMedicalFacility: textSchema,
        },
      },
      'view:addtlInfo': emptyObjectSchema,
      wantsInitialVaContact,
    },
  },
};
